import api from '~/services/api';
import PropTypes from 'prop-types';
import errorHandler from '~/Utils/errorHandler';
import { message } from 'antd';
import i18next from 'i18next';

const endPoint = 'events';

// GET
export const getEvents = async (params, route = '') => {
  try {
    const { data } = await api.get(`/${endPoint}/${route}`, params);
    return data.data;
  } catch (error) {
    throw error;
  }
};

// CREATE
export const createEvents = async (values, routes = '') => {
  try {
    const { data } = await api.post(`/${endPoint}/${routes}`, values);
    return data.data;
  } catch (error) {
    throw error;
  }
};

// UPDATE
export const updateEvents = async (id, values) => {
  try {
    const { data } = await api.put(`/${endPoint}/${id}`, values);
    return data.data;
  } catch (error) {
    throw error;
  }
};

// DELETE
export const deleteEvents = async (id) => {
  try {
    const { data } = await api.delete(`/${endPoint}/${id}`);
    message.success(i18next.t(`messages:${endPoint}.successDelete`));
    return data.data;
  } catch (error) {
    errorHandler(error);
  }
};

export const pdfEvents = async (values, route = '') => {
  try {
    const response = await api.post(`/${endPoint}/${route}`, values);
    return response;
  } catch (error) {
    throw error;
  }
};

getEvents.propTypes = {
  params: PropTypes.object.isRequired,
};

createEvents.propTypes = {
  values: PropTypes.object.isRequired,
};

updateEvents.propTypes = {
  values: PropTypes.object.isRequired,
};

deleteEvents.propTypes = {
  id: PropTypes.string.isRequired,
};
